module.exports = __webpack_public_path__ + "static/wave-4558b8d59879492c53c568ca192b1399.png";